import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivationEnd, Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '@environments/environment';
import { BehaviorSubject, filter, map } from 'rxjs';
import { Title } from '@angular/platform-browser';

interface Breadcrumb {
  label: string;
  routerLink?: Array<string>;
}

@Component({
  selector: '[app-breadcrumb]',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  template: `<nav class="layout-breadcrumb">
    <ol>
      <ng-template ngFor let-item let-last="last" [ngForOf]="breadcrumbs$ | async">
        <li class="text-surface-950 dark:text-surface-0 title-h7 text-xl">
          {{ item.label }}
        </li>
        <li *ngIf="!last" class="layout-breadcrumb-chevron">/</li>
      </ng-template>
    </ol>
  </nav> `,
})
export class AppBreadcrumb {
  private readonly _breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([]);

  readonly breadcrumbs$ = this._breadcrumbs$.asObservable();

  constructor(
    private router: Router,
    public title: Title,
    private translateService: TranslateService,
  ) {
    this.router.events
      .pipe(
        filter((event) => event instanceof ActivationEnd),
        filter((event: ActivationEnd) => event.snapshot.firstChild === null),
        map((event: ActivationEnd) => event.snapshot.data),
      )
      .subscribe((event) => {
        const breadcrumbs: Breadcrumb[] = [];
        this.addBreadcrumb(event, breadcrumbs);

        this._breadcrumbs$.next(breadcrumbs);
      });
  }

  private addBreadcrumb(data: any, breadcrumbs: Breadcrumb[]) {
    // * only show title instead of breadcrums
    if (data.title) {
      const label = this.translateService.instant(data.title);
      breadcrumbs.push({ label });
      this.title.setTitle(`${label} - ${environment.appName}`);
    } else {
      breadcrumbs.push({ label: 'NO TITLE' });
      this.title.setTitle(`${environment.companyName} - ${environment.appName}`);
    }
  }
}
